export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
    case 'CIRCLES_SET':
      return payload
    case 'CIRCLE_CREATE':
      return [payload, ...state]
    case 'CIRCLE_UPDATE':
      return state.map(item => {
        if (item.id != payload.id) return item
        const updated = Object.assign({}, item, payload)
        delete updated.mapObj
        return updated
      })
    case 'CIRCLE_DELETE':
      return state.filter(item => item.id != payload)
    case 'CIRCLE_LOGOUT':
      return []
    case 'LOGOUT':
      return []
    default:
      return state
  }
}
